module.exports = __webpack_public_path__ + "img/northerncyprus.7a05d214.svg";